import ButtonOpenMobileMenu from "@/components/shared/buttons/ButtonOpenMobileMenu";
import HeaderCartShow from "./HeaderCartShow";
import {useTranslations} from 'next-intl';
import HeaderAccountSelector from '@/components/layout/headers/HeaderAccountSelector';
import Form from 'next/form';

export default function HeaderRight({headerStyle, currency}) {
  const t = useTranslations('header');
  return (
    <div className={`ltn__header-options  ${headerStyle === 3 ? "col" : "ltn__header-options-2"}`}>
      {/* <!-- header-search-1 --> */}{" "}
      <div className="header-search-wrap">
        <div className="header-search-1">
          <div className="search-icon">
            <i className="icon-search for-search-show"></i>
            <i className="icon-cancel  for-search-close"></i>
          </div>
        </div>
        <div className="header-search-1-form">
          <Form action="/catalog">
            <input
                type="text"
                name="search"
                placeholder={t('searchHere')}
            />
            <button type="submit">
              <span>
                <i className="icon-search"></i>
              </span>
            </button>
          </Form>
        </div>
      </div>
      {/* <!-- user-menu --> */}
      <HeaderAccountSelector/>
      
      {/* <!-- mini-cart --> */}
      {<HeaderCartShow headerStyle={headerStyle} currency={currency}/>}
      
      {/* <!-- mini-cart --> */}
      {/* <!-- Mobile Menu Button --> */}
      <ButtonOpenMobileMenu headerStyle={headerStyle}/>
    </div>
  );
};
